// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__DuhuF","label":"SetPasswdForm_label__3lcWg"};